(() => {
  const sampleKeys = ['Sample service optie', 'Sample service selectie', 'Sample service voorkeuren', 'Aantal premium samples', '_sample_ids', '_sample_names', '_sample_type_counts', '_sample_price_choices', '_sample_surcharge_cents', '_premium_sample_count'];
  const idsOf = item => String(item.properties?._sample_ids || '').split(',').map(s => s.trim()).filter(Boolean);
  function namesOf(item) {
    const ids = idsOf(item);
    let names;
    try { names = JSON.parse(item.properties?._sample_names || 'null'); } catch { /* Older sets use their visible selection. */ }
    if (!Array.isArray(names)) {
      const selection = String(item.properties?.['Sample service selectie'] || '');
      const list = /^(?:Custom )?Set: /.test(selection) ? selection.match(/ \((.*)\)$/)?.[1] || '' : selection;
      names = list.split(',').map(name => name.trim());
    }
    return names.length === ids.length && names.every(name => typeof name === 'string' && name.trim())
      ? Object.fromEntries(ids.map((id, index) => [id, names[index]])) : {};
  }
  const isSet = item => item.handle === 'sample-service' || /\/products\/sample-service(?:[?#]|$)/.test(item.url || '');
  const isChosen = item => isSet(item) && (!!item.properties?._sample_ids || !['Door Ornata', 'Verras me'].includes(item.properties?.['Sample service optie']));
  const signature = item => JSON.stringify([String(item.variant_id || item.id), Object.entries(item.properties || {}).filter(([, v]) => v !== '' && v != null).sort(([a], [b]) => a.localeCompare(b))]);
  function findOriginal(cart, context) {
    const matches = cart.items.filter(item => signature(item) === context.signature);
    return matches.find(item => item.key === context.key) || (matches.length === 1 ? matches[0] : null);
  }
  function inspect(item, inventory) {
    if (!isChosen(item)) return null;
    const ids = idsOf(item);
    const validIds = ids.length === 5 && new Set(ids).size === 5 && ids.every(id => /^\d+$/.test(id));
    const missing = ids.filter(id => inventory.byProductId[id]?.selectable !== true);
    const surcharge = ids.reduce((sum, id) => sum + Number(inventory.byProductId[id]?.sampleSurchargeCents || 0), 0);
    const variant = inventory.pricing?.variants?.find(v => v.available !== false && Number(v.surchargeCents) === surcharge);
    if (!validIds || missing.length) return { kind: 'stock', missing, retained: ids.length - missing.length };
    if (!variant || String(variant.id) !== String(item.variant_id || item.id)) return { kind: 'price', missing: [], retained: 5 };
    return null;
  }
  function mergeProperties(previous, next, token) {
    const properties = { ...previous };
    sampleKeys.forEach(key => delete properties[key]);
    return { ...properties, ...next, _sample_cart_edit: token };
  }
  const helpers = { idsOf, namesOf, isChosen, signature, findOriginal, inspect, mergeProperties };
  if (typeof module !== 'undefined' && module.exports) { module.exports = helpers; return; }
  const configNode = document.getElementById('ornata-sample-cart-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const copy = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', String(value)), config.copy[key] || '');
  const journalKey = 'ornata:sample-cart-repair:v1';
  let cachedInventory, inventoryTime = 0, inventoryFlight, checkFlight, lastResult, timer, updating = false;
  async function request(url, options = {}) {
    const result = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000), ...options });
    const value = await result.json();
    if (!result.ok) throw new Error(value.description || copy('connection_error'));
    return value;
  }
  const readCart = () => request(root + 'cart.js');
  const post = (path, data) => request(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(data) });
  function journal() { try { return JSON.parse(localStorage.getItem(journalKey) || 'null'); } catch { return null; } }
  function saveJournal(value) {
    if (value) localStorage.setItem(journalKey, JSON.stringify(value));
    else localStorage.removeItem(journalKey);
  }
  async function inventory(force = false) {
    if (inventoryFlight) return inventoryFlight;
    if (!force && cachedInventory && Date.now() - inventoryTime < 15000) return cachedInventory;
    inventoryFlight = request(config.endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'availability', shopDomain: config.shop }) }).then(payload => {
      if (payload.status !== 'ok' || payload.data?.source !== 'supabase' || !Array.isArray(payload.data.samples)) throw new Error(copy('connection_error'));
      cachedInventory = { ...payload.data, byProductId: Object.fromEntries(payload.data.samples.map(item => [String(item.productId), item])) };
      inventoryTime = Date.now();
      return cachedInventory;
    }).finally(() => { inventoryFlight = null; });
    return inventoryFlight;
  }
  function editUrl(key) {
    const url = new URL(config.productUrl, location.origin);
    url.searchParams.set('edit_sample_set', key);
    return url.pathname + url.search;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function notice(node, issue, item, data) {
    node.replaceChildren();
    node.hidden = !issue;
    if (!issue) return;
    const savedNames = namesOf(item);
    const names = (issue.missing || []).map(id => data?.byProductId[id]?.title || data?.byProductId[id]?.name || savedNames[id]).filter(Boolean);
    let message = copy('stock_generic');
    if (issue.kind === 'stock' && names.length === issue.missing.length && names.length) message = copy(names.length === 1 ? 'stock_one' : 'stock_many', { names: names.join(', ') });
    if (issue.kind === 'price') message = copy('price_changed');
    if (issue.kind === 'error') message = copy('connection_error');
    if (issue.kind === 'pending') message = copy('pending');
    node.append(element('p', 'sample-cart-notice__title', copy(issue.kind === 'error' ? 'check_title' : issue.kind === 'pending' ? 'pending_title' : 'title')));
    node.append(element('p', 'sample-cart-notice__text', message));
    if (issue.kind === 'stock' && issue.retained > 0 && issue.retained < 5) node.append(element('p', 'sample-cart-notice__text', copy(issue.retained === 1 ? 'retained_one' : 'retained_many', { count: issue.retained })));
    const link = element(issue.kind === 'error' ? 'button' : 'a', 'link sample-cart-notice__link', copy(issue.kind === 'error' ? 'retry' : issue.kind === 'pending' ? 'finish' : 'edit'));
    if (issue.kind === 'error') { link.type = 'button'; link.addEventListener('click', () => check(true)); }
    else link.href = editUrl(issue.editKey || item.key);
    node.append(link);
  }
  function paint(result) {
    document.querySelectorAll('[data-sample-cart-line]').forEach(node => {
      const item = result.cart?.items.find(item => item.key === node.dataset.lineKey);
      notice(node, item ? result.issues.get(item.key) : null, item, result.inventory);
    });
    document.querySelectorAll('[data-sample-cart-summary]').forEach(node => {
      node.hidden = !result.issues.size;
      node.textContent = copy(result.error ? 'connection_error' : 'checkout_blocked');
    });
    document.querySelectorAll('form[action*="/cart"] [name="checkout"]').forEach(button => {
      if (result.issues.size) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(node => { node.hidden = result.cart?.items.some(isChosen) || false; });
  }
  async function check(force = false) {
    if (updating) return lastResult;
    if (checkFlight) { await checkFlight; if (force) return check(true); return lastResult; }
    checkFlight = (async () => {
      let cart;
      try {
        cart = await readCart();
        const chosen = cart.items.filter(isChosen), issues = new Map();
        const data = chosen.length ? await inventory(force) : null;
        chosen.forEach(item => { const issue = inspect(item, data); if (issue) issues.set(item.key, issue); });
        const pending = journal();
        if (pending?.cartToken === cart.token) {
          const added = cart.items.find(item => item.properties?._sample_cart_edit === pending.token);
          const original = findOriginal(cart, pending.context);
          if (added && original) [original, added].forEach(item => issues.set(item.key, { kind: 'pending', editKey: pending.context.key }));
        }
        lastResult = { cart, inventory: data, issues };
      } catch (error) {
        const items = cart?.items.filter(isChosen) || [...document.querySelectorAll('[data-sample-cart-line]')].map(node => ({ key: node.dataset.lineKey }));
        lastResult = { cart: cart || { items }, error, issues: new Map(items.map(item => [item.key, { kind: 'error' }])) };
      }
      paint(lastResult);
      return lastResult;
    })().finally(() => { checkFlight = null; });
    return checkFlight;
  }
  async function requireValid() {
    const result = await check(true);
    if (!result || result.error || result.issues.size) {
      const visible = [...document.querySelectorAll('[data-sample-cart-line]:not([hidden])')].find(node => node.getClientRects().length);
      if (visible) { visible.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); visible.querySelector('a,button')?.focus({ preventScroll: true }); }
      const error = new Error(copy(result?.error ? 'connection_error' : 'checkout_blocked'));
      error.sampleCart = true;
      throw error;
    }
    return result.cart;
  }
  async function openEdit(key) {
    const cart = await readCart(), pending = journal();
    let item = cart.items.find(item => item.key === key);
    if (pending?.context.key === key && pending.cartToken === cart.token) item = cart.items.find(item => item.properties?._sample_cart_edit === pending.token) || findOriginal(cart, pending.context);
    if (!item || !isChosen(item)) throw new Error(copy('missing_set'));
    return { item, key, signature: signature(item), cartToken: cart.token };
  }
  async function replace(context, value) {
    const work = async () => {
      updating = true;
      try {
        let cart = await readCart(), pending = journal();
        if (cart.token !== context.cartToken) throw new Error(copy('missing_set'));
        if (pending && pending.cartToken !== cart.token) { saveJournal(null); pending = null; }
        if (pending && pending.context.key !== context.key) throw new Error(copy('other_pending'));
        if (pending) {
          const added = cart.items.find(item => item.properties?._sample_cart_edit === pending.token);
          const original = findOriginal(cart, pending.context);
          const sameSelection = String(pending.variantId) === String(value.variantId) && sampleKeys.every(key => String(pending.properties[key] || '') === String(value.properties[key] || ''));
          if (added && !original && sameSelection) { saveJournal(null); return cart; }
          if (!sameSelection) {
            if (added && original) {
              await post('cart/change.js', { id: added.key, quantity: 0 });
              cart = await readCart();
              if (cart.items.some(item => item.properties?._sample_cart_edit === pending.token)) throw new Error(copy('pending'));
            } else if (added) {
              context = { ...context, key: added.key, signature: signature(added) };
            }
            if (original) context = { ...context, key: original.key, signature: signature(original) };
            saveJournal(null);
            pending = null;
          }
        }
        if (!pending) {
          const original = findOriginal(cart, context);
          if (!original) throw new Error(copy('missing_set'));
          const token = crypto.randomUUID();
          pending = { cartToken: cart.token, context, token, quantity: original.quantity, variantId: value.variantId, properties: mergeProperties(original.properties, value.properties, token) };
          saveJournal(pending);
        }
        let added = cart.items.find(item => item.properties?._sample_cart_edit === pending.token);
        if (!added) {
          const original = findOriginal(cart, pending.context);
          if (!original || original.quantity !== pending.quantity) { saveJournal(null); throw new Error(copy('cart_changed')); }
          try { await post('cart/add.js', { items: [{ id: pending.variantId, quantity: pending.quantity, properties: pending.properties }] }); }
          catch (error) {
            cart = await readCart();
            if (!cart.items.some(item => item.properties?._sample_cart_edit === pending.token)) { saveJournal(null); throw error; }
          }
          cart = await readCart();
          added = cart.items.find(item => item.properties?._sample_cart_edit === pending.token);
        }
        if (!added || added.quantity !== pending.quantity) throw new Error(copy('pending'));
        const original = findOriginal(cart, pending.context);
        if (original) {
          if (original.quantity !== pending.quantity) throw new Error(copy('cart_changed'));
          try { await post('cart/change.js', { id: original.key, quantity: 0 }); }
          catch (error) {
            cart = await readCart();
            if (findOriginal(cart, pending.context)) throw new Error(copy('pending'));
          }
        }
        cart = await readCart();
        if (findOriginal(cart, pending.context) || !cart.items.some(item => item.properties?._sample_cart_edit === pending.token)) throw new Error(copy('pending'));
        saveJournal(null);
        return cart;
      } finally { updating = false; }
    };
    return navigator.locks?.request ? navigator.locks.request('ornata-sample-cart-repair', work) : work();
  }
  function schedule(force = false) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (document.querySelector('[data-sample-cart-line]')) void check(force);
      else if (lastResult) { lastResult = { cart: { items: [] }, issues: new Map() }; paint(lastResult); }
    }, 100);
  }
  document.addEventListener('cart:change', () => schedule(true));
  document.addEventListener('cart-drawer:refreshed', () => { if (lastResult) paint(lastResult); schedule(); });
  document.addEventListener('dialog:before-show', event => { if (event.target.matches('cart-drawer')) schedule(); }, true);
  window.addEventListener('pageshow', () => schedule(true));
  window.addEventListener('focus', () => schedule(true));
  window.addEventListener('storage', event => { if (event.key === journalKey) schedule(true); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(true); });
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/.test(url.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try { await requireValid(); window.location.assign(url.href); } catch { document.querySelector('cart-drawer')?.show?.(); }
  }, true);
  window.OrnataSampleCart = { ...helpers, check, requireValid, openEdit, replace, copy, editUrl };
  schedule();
})();
